var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__content"},[_c('p',{staticClass:"loader__content__number"},[_vm._v(_vm._s(_vm.loadervalue)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }